import { render } from "./CardPayment.vue?vue&type=template&id=3b820276&scoped=true"
import script from "./CardPayment.vue?vue&type=script&lang=js"
export * from "./CardPayment.vue?vue&type=script&lang=js"

import "./CardPayment.vue?vue&type=style&index=0&id=3b820276&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b820276"]])

export default __exports__